import {
  type GenerateStyle,
  genComponentStyleHook,
  type FullToken,
} from "antd/es/theme/internal";
import { calendarPrefixCls } from "@/base/components/calendar/Calendar.component";
import { THEME_PREFIX } from "@/base/constant";

const genStyle: GenerateStyle<FullToken<"Calendar">> = ({
  colorTextHeading,
}: any) => ({
  [`.${THEME_PREFIX}`]: {
    [`&.${calendarPrefixCls}`]: {
      [`thead th`]: {
        color: `${colorTextHeading} !important`,
      },
    },
  },
});

export const useCalendarStyle = genComponentStyleHook(
  ["Calendar", "cso"],
  (token) => {
    return [genStyle(token)];
  },
);
